<nz-spin [nzSpinning]="loading$ | async"
  ><div class="drawer-form-wrapper">
    <h3 class="title s-16 mb-16">
      {{ drawerParmas.selectedDay }},
      {{ drawerParmas.selectedDate | date: 'MMMM dd, yyyy' }}
    </h3>
    <form nz-form class="form" [formGroup]="frquencyIntervalForm">
      <div class="form-grid">
        <nz-form-item>
          <nz-form-label nzFor="type" nzRequired>Enter Frequency</nz-form-label>
          <nz-form-control>
            <input
              name="minutes"
              type="text"
              nz-input
              [mask]="'000'"
              [validation]="false"
              appAllowOnlyValidNumbers
              id="minutes"
              formControlName="frequency"
              placeholder="Enter frequency" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div
        class="ant-form-item-explain-error mt-3 mb-3"
        *ngIf="!frquencyIntervalForm.value.frequency">
        Please enter Frequency value.
      </div>
    </form>
    <p class="error-text mb-24">Enter numeric value for Frequency Only.</p>
    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button type="button" nzType="default" (click)="onCancel()">
        Cancel
      </button>
      <button
        nz-button
        type="button"
        nzType="primary"
        (click)="submitForm()"
        [disabled]="!frquencyIntervalForm.value.frequency">
        Save
      </button>
    </div>
  </div>
</nz-spin>
